export default __webpack_public_path__ + "84d3233898f441bc674ac0d1f102280e.png";